import { render, staticRenderFns } from "./LandingWelcome.vue?vue&type=template&id=42be5622&scoped=true&"
import script from "./LandingWelcome.vue?vue&type=script&lang=js&"
export * from "./LandingWelcome.vue?vue&type=script&lang=js&"
import style0 from "./LandingWelcome.vue?vue&type=style&index=0&id=42be5622&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42be5622",
  null
  
)

export default component.exports